// Author Shi Wen Long
// Date 2021-10-29 11:40:55

import * as model from "@/model/sithMes/prd/SithMesPrdPpNetworkModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdPpNetwork(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .buildStore()
